export default __webpack_public_path__ + "static/10-mouth-watering-destinations-for-unashamed-foodies-france-43f8dd73ae1f1fd44c6bfba52ad0479e.jpg";